import { ReactNode } from "react"
import { htmlToText } from "html-to-text"

export const ellipsisText = (value = "", limit = 255) => {
  let text = htmlToText(`${value.trim()}`, {
    tags: {
      // @ts-ignore
      figure: { format: "skip" },
      img: { format: "skip" },
      a: { format: "skip" },
    },
  })

  text = text.replace(/(\r\n|\n|\r)/gi, " ")
  text = text.replace(/\u00A0/gi, " ")
  if (text.length > limit) {
    for (let i = limit; i > 0; i--) {
      if (
        text.charAt(i) === " " &&
        (text.charAt(i - 1) !== "," ||
          text.charAt(i - 1) !== "." ||
          text.charAt(i - 1) !== ";")
      ) {
        return text.substring(0, i) + "..."
      }
    }
    return text.substring(0, limit) + "..."
  } else return text
}

// Usage: Some string {message::value} foo bar
export const parseTemplate = (
  template = "",
  render: (message: string, value?: string) => string | ReactNode,
) => {
  if (!template) {
    return null
  }
  return template.split(/{(.*?)}/g).map((value) => {
    if (value.includes("::")) {
      const [message, data] = value.split("::")
      return render(message, data || "span")
    } else {
      return value
    }
  })
}

export function b64DecodeUnicode(str) {
  return decodeURIComponent(
    window
      .atob(str)
      .split("")
      .map((c) => {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join(""),
  )
}
